import {Portal} from "@material-ui/core";
import React, {useState} from "react";
import CustomSnackbar from "../widget/alerts/CustomSnackbar";

export const withSnackbar = WrappedComponent => {
    const GlobalSnackbar = (props) => {
        const [open, setOpen] = useState(false);
        const [type, setType] = useState("info");
        const [message, setMessage] = useState("");
        const [withIcon, setWithIcon] = useState(false);
        const [buttonTextSnackbar, setButtonTextSnackbar] = useState(undefined);
        const [vertical, setVertical] = useState("bottom");
        const [horizontal, setHorizontal] = useState("center");
        const [hideDuration, setHideDuration] = useState(5000);
        const [animationDirection, setAnimationDirection] = useState("up");
        const [contentClassName, setContentClassName] = useState();
        const [className, setClassName] = useState();
        const [closeIcon, setCloseIcon] = useState(false);

        const handleShowSnackbar = ({
            type,
            message,
            withIcon,
            buttonTextSnackbar,
            vertical,
            horizontal,
            hideDuration,
            animationDirection,
            contentClassName,
            className,
            closeIcon
        }) => {
            setType(type || "info");
            setMessage(message || "");
            setWithIcon(withIcon);
            setButtonTextSnackbar(buttonTextSnackbar);
            setVertical(vertical || "bottom");
            setHorizontal(horizontal || "center");
            setHideDuration(hideDuration || 5000);
            setAnimationDirection(animationDirection || "up");
            setContentClassName(contentClassName);
            setClassName(className);
            setCloseIcon(closeIcon);
            setOpen(true);
        };

        const handleCloseSnackbar = () => {
            setOpen(false);
        };

        return (
            <>
                <WrappedComponent
                    {...props}
                    showSnackbar={handleShowSnackbar}
                    closeSnackbar={handleCloseSnackbar}
                />
                {open &&
                    <Portal>
                        <CustomSnackbar
                            className={className}
                            message={message}
                            open={open}
                            type={type}
                            withIcon={withIcon}
                            buttonText={buttonTextSnackbar}
                            vertical={vertical}
                            horizontal={horizontal}
                            hideDuration={hideDuration}
                            animationDirection={animationDirection}
                            contentClassName={contentClassName}
                            closeIcon={closeIcon}
                            onClose={handleCloseSnackbar}
                        />
                    </Portal>
                }
            </>
        );
    };
    return GlobalSnackbar;
};
